export const ROUTE = "interaction";
